import React, { useLayoutEffect, useRef, useState } from 'react'
import { formatTokenAmount } from './formatAmount'

const shortAddress = (value) => value ? `${value.slice(0, 6)}...${value.slice(-4)}` : '-'

function ProjectDescription({ description, t }) {
    const textRef = useRef(null)
    const [expanded, setExpanded] = useState(false)
    const [canToggle, setCanToggle] = useState(false)

    useLayoutEffect(() => {
        const measure = () => {
            if (expanded || !textRef.current) return
            setCanToggle(textRef.current.scrollHeight > textRef.current.clientHeight + 1)
        }
        measure()
        window.addEventListener('resize', measure)
        return () => window.removeEventListener('resize', measure)
    }, [description, expanded])

    return <div className="console-project-summary">
        <span className="console-eyebrow">{t('项目简介')}</span>
        <p ref={textRef} className={`console-project-summary__text ${expanded ? 'is-expanded' : ''}`}>{description}</p>
        {canToggle && <button type="button" className="console-project-summary__toggle" onClick={() => setExpanded((value) => !value)}>
            {expanded ? t('收起简介') : t('展开简介')}
            <i className={`fa ${expanded ? 'fa-chevron-up' : 'fa-chevron-down'}`} aria-hidden="true" />
        </button>}
    </div>
}

export default function PoolOverview({ state, t, getLockTimeString, onCopy }) {
    const { poolInfo = {}, stakeTokenInfo = {}, rewardTokenInfo = {}, ipfsInfo = {}, contract } = state
    const stakeSymbol = stakeTokenInfo.isPairToken ? `${stakeTokenInfo?.token0Info?.symbol || ''}/${stakeTokenInfo?.token1Info?.symbol || ''}` : stakeTokenInfo.symbol || '-'
    const tokenCards = [
        {
            label: t('质押代币'),
            logo: ipfsInfo.stakedTokenLogo,
            symbol: stakeSymbol,
            name: stakeTokenInfo.name || '-',
            tone: 'stake',
            address: stakeTokenInfo.address,
            copyLabel: t('复制质押代币合约'),
        },
        {
            label: t('奖励代币'),
            logo: ipfsInfo.rewardTokenLogo,
            symbol: rewardTokenInfo.symbol || '-',
            name: rewardTokenInfo.name || '-',
            tone: 'reward',
            address: rewardTokenInfo.address,
            copyLabel: t('复制奖励代币合约'),
        },
    ]
    return <section className="console-section console-pool-overview">
        <div className="console-token-identity">
            <div className="console-token-identity__heading">
                <span className="console-token-identity__label">{t('资产身份')}</span>
                <div className="console-pool-contract">
                    <span>{t('矿池合约')}</span>
                    <button type="button" aria-label={t('复制矿池合约')} onClick={() => onCopy(contract)} title={contract}>
                        {shortAddress(contract)} <i className="fa fa-copy" aria-hidden="true" />
                    </button>
                </div>
            </div>
            <div className="console-token-identity__grid">
                {tokenCards.map((token) => <article className={`console-token-card is-${token.tone}`} key={token.tone}>
                    <div className="console-token-logo">
                        {token.logo ? <img src={token.logo} alt={token.symbol} /> : <span aria-hidden="true">{token.symbol.slice(0, 1)}</span>}
                    </div>
                    <div>
                        <small>{token.label}</small>
                        <strong>{token.symbol}</strong>
                        <span>{token.name}</span>
                        <button type="button" className="console-token-contract" aria-label={token.copyLabel} onClick={() => onCopy(token.address)} title={token.address}>
                            <small>{t('代币合约')}</small><span>{shortAddress(token.address)}</span><i className="fa fa-copy" aria-hidden="true" />
                        </button>
                    </div>
                </article>)}
            </div>
        </div>
        {ipfsInfo.description && <ProjectDescription description={ipfsInfo.description} t={t} />}
        <dl className="console-metric-grid">
            <div><dt>{t('开始时间')}</dt><dd>{poolInfo.startTime?.format?.('YYYY-MM-DD HH:mm') || '-'}</dd></div>
            <div><dt>{t('结束时间')}</dt><dd>{poolInfo.endTime?.format?.('YYYY-MM-DD HH:mm') || '-'}</dd></div>
            <div><dt>{t('锁仓时间')}</dt><dd>{poolInfo.lockTime > 0 ? getLockTimeString(poolInfo.lockTime) : t('无锁仓')}</dd></div>
            <div><dt>{t('最大质押量')}</dt><dd>{poolInfo.poolLimitPerUser > 0 ? `${formatTokenAmount(poolInfo.poolLimitPerUser, stakeTokenInfo.decimals)} ${stakeTokenInfo.symbol || ''}` : t('不限')}</dd></div>
        </dl>
    </section>
}
